/**
 * An enumeration of edit actions a user might be performing.
 */
export enum EditType {
  /** It describes that a user is creating an item. */
  CREATE = 'CREATE',

  /** It describes that a user is editing an item. */
  EDIT = 'EDIT',

  /** It describes that a user is deleting an item. */
  DELETE = 'DELETE'
}
